import React from "react";
import time from "@/public/images/time.svg";
import exam from "@/public/images/exam.svg";
import bookmark from "@/public/images/bookmark.svg";
import Image from "next/image";
import MyLink from "../myLink/MyLink";

const ExamCard = ({ exam }: { exam: any }) => {
  return (
    <div
      data-aos="fade-up"
      className="p-5 bg-[#232c37] rounded-[15px] w-fit border border-[#56566B] flex flex-col gap-5 justify-between h-full"
    >
      <Image
        src={exam?.image}
        alt={exam?.name}
        className="w-[400px] h-[220px] object-cover rounded-[10px]"
        height={220}
        width={400}
      />
      <div className="flex items-center gap-3">
        <Image src={bookmark} alt="Bookmark Icon" />
        <p className="text-16 text-primaryColor font-[400]">
          {exam.school_years?.map((year: any) => year?.name).join(", ")}
        </p>
      </div>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-start gap-3">
          {exam?.teacher?.image && (
            <Image
              src={exam.teacher.image}
              alt={exam.teacher.name}
              width={64}
              height={64}
              className="rounded-[10px]"
            />
          )}
          <div>
            <p className="text-14 text-white font-[500]">
              {exam?.teacher?.name}
            </p>
            <p className="text-12 text-textColor">
              {exam?.teacher?.subject_name}
            </p>
          </div>
        </div>
        <p className="text-14 text-primaryColor font-[600] text-center py-[5px] px-2 rounded-full border border-primaryColor">
          {exam.price ? `${exam?.price} جنية` : "مجاني"}
        </p>
      </div>
      <h4 className="text-white text-[20px] font-[600] line-clamp-2">
        {exam?.name}
      </h4>
      <div className="bg-[#333e4b] rounded-[10px] flex items-center justify-between py-3 px-3 md:px-3">
        <div className="flex flex-col gap-1 items-center justify-center grow">
          <Image src={time} alt="Time Icon" />
          <p className="text-16 text-textColor font-[500]">
            {exam?.duration} دقيقه
          </p>
        </div>
        <div className="flex flex-col gap-1 items-center justify-center grow border-r border-[#6F7275]">
          <Image src={exam} alt="Exam Icon" />
          <p className="text-16 text-textColor font-[500]">
            {exam?.number_of_questions} سؤال
          </p>
        </div>
      </div>
      <MyLink
        href={`/viewFullExam/${exam?.id}`}
        className="text-center text-13 font-[500] text-[#1b252f] bg-primaryColor rounded-[7px] py-2 px-5"
      >
        عرض تفاصيل الامتحان
      </MyLink>
    </div>
  );
};

export default ExamCard;
